import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnalyticsService } from '../../core/analytics';
import { VersionService } from '@spotlight/shared/version';

export interface UpdateAvailableDialogData {
  currentVersionHash?: string;
  latestVersionHash?: string;
}

@Component({
  selector: 'app-update-available-dialog',
  templateUrl: './update-available-dialog.component.html',
  styleUrls: ['./update-available-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UpdateAvailableDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<UpdateAvailableDialogComponent>,
    private readonly analytics: AnalyticsService,
    private readonly versionService: VersionService,
    @Inject(MAT_DIALOG_DATA) private readonly data: UpdateAvailableDialogData | null
  ) {}

  public refresh() {
    this.analytics.sendEvent('Update Available Refresh Clicked', {
      appVersion: this.versionService.getVersion(),
      currentVersionHash: this.data?.currentVersionHash,
      latestVersionHash: this.data?.latestVersionHash,
    });
    this.dialogRef.close();
    globalThis.location.reload();
  }
}
